import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "../elements/elements.settings";
import { CONTAINERS_GUI_FIELDS } from "./containers.settings";

const { Général: GEN } = CONTAINERS_GUI_FIELDS;
const { "Taille & Espacements": SPACE } = ELEMENTS_GUI_FIELDS;

export const X_CATEGORY_FILTER_GUI_FIELDS: TXGUISection = {
  Général: [
    ...(GEN ?? []),
    {
      type: "toggle_option",
      name: "filterPosition",
      label: "Position du filtreur",
      options: [
        { value: "left", label: "Gauche" },
        { value: "right", label: "Droite" },
      ],
      defaultValue: "left",
    },
    {
      type: "color",
      name: "filterBgColor",
      label: "Arriere Plan deu filtreur",
    },
    {
      type: "sizing",
      name: "filterWidth",
      label: "Largeur du filtreur",
      units: ["px"],
      defaultValue: "300px",
    },
    {
      type: "sides",
      name: "filterPadding",
      label: "Espace Interne Du Filtreur",
      units: ["px", "em", "%", "auto"],
    },
    {
      type: "select_option",
      name: "columns",
      label: "Colones",
      options: [
        { value: 2, label: "2 Colones" },
        { value: 3, label: "3 Colones" },
        { value: 4, label: "4 Colones" },
        { value: 5, label: "5 Colones" },
        { value: 6, label: "6 Colones" },
        { value: 7, label: "7 Colones" },
        { value: 8, label: "8 Colones" },
      ],
      defaultValue: 3,
    },

    {
      type: "color",
      name: "textColor",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "sizing",
      name: "fontSize",
      label: "Taille de la police",
      placeholder: "10",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "16px",
    },
    {
      type: "toggle_option",
      name: "divider",
      label: "Separateur",
      options: [
        { value: true, label: "Oui" },
        { value: false, label: "Non" },
      ],
      defaultValue: false,
    },
    {
      type: "sizing",
      name: "sectionGap",
      label: "Espacement des sections",
      units: ["px", "em"],
      defaultValue: "20px",
    },
    {
      type: "toggle_option",
      name: "showCount",
      label: "Afficher Quantite",
      options: [
        { value: true, label: "Oui" },
        { value: false, label: "Non" },
      ],
      defaultValue: false,
    },
  ],
  "Taille & Espacements": SPACE,
  "Titre des Sections": [
    {
      type: "sizing",
      name: "titleFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "18px",
    },
    {
      type: "select_option",
      name: "titleFontWeight",
      label: "Epaisseur de la police",
      options: [
        { value: 100, label: "Mince" },
        { value: 200, label: "Tres Léger" },
        { value: 300, label: "Léger" },
        { value: 400, label: "Normal" },
        { value: 500, label: "Moyen" },
        { value: 600, label: "Semi-gras" },
        { value: 700, label: "Gras" },
        { value: 800, label: "Extra Gras" },
        { value: 900, label: "Lourd" },
      ],
      defaultValue: 500,
    },
    {
      type: "toggle_option",
      name: "titleFontStyle",
      label: "Style de la police",
      options: [{ value: "normal" }, { value: "italic" }],
      defaultValue: "normal",
    },
    {
      type: "color",
      name: "titleColor",
      label: "Couleur du texte",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "titleBgColor",
      label: "Arriere Plan",
    },
    {
      type: "sizing",
      name: "titleHeight",
      label: "Hauteur du Titre",
      units: ["px", "em"],
      defaultValue: "50px",
    },
  ],
  CheckBox: [
    {
      type: "color",
      name: "checkboxTextColor",
      label: "Couleur des textes",
    },
    {
      type: "sizing",
      name: "checkboxSize",
      label: "Taille du checkbox",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "20px",
    },
    {
      type: "color",
      name: "checkboxColor",
      label: "Couleur Active",
    },
  ],
  "Choix de Couleurs": [
    {
      type: "border",
      name: "colorPickerBorder",
      label: "Contoure Actif",
      units: ["px", "em"],
    },
    {
      type: "sizing",
      name: "colorPickerSize",
      label: "Taille",
      units: ["px", "em"],
    },
  ],
  "Intervalle de Prix": [
    {
      type: "toggle_option",
      name: "pricingMode",
      label: "Mode",
      options: [
        { value: "column", label: "Vertical" },
        { value: "row", label: "En Ligne" },
        { value: "auto", label: "Auto" },
      ],
      defaultValue: "column",
    },
    {
      type: "color",
      name: "pricingLineColor",
      label: "Couleur de la ligne",
    },
    {
      type: "sizing",
      name: "pricingLineHeight",
      label: "Hauteur de la ligne",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "pricingActiveLineColor",
      label: "Couleur de la ligne (Active)",
    },
    {
      type: "sizing",
      name: "pricingActiveLineHeight",
      label: "Hauteur de la ligne (Active)",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "pricingHandlerColor",
      label: "Couleur des manches",
    },
    {
      type: "border",
      name: "pricingHandlerBorder",
      label: "Bordure des Manches",
      units: ["px", "em"],
    },
    {
      type: "sizing",
      name: "pricingHandlerHeight",
      label: "Hauteur des manches",
      units: ["px", "em"],
    },
    {
      type: "sizing",
      name: "pricingHandlerWidth",
      label: "Largeur des manches",
      units: ["px", "em"],
    },
    {
      type: "radius",
      name: "pricingHandlerRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "color",
      name: "pricingHoverHandlerColor",
      label: "Couleur des manches (Survole)",
    },
    {
      type: "border",
      name: "pricingHoverHandlerBorder",
      label: "Bordure des Manches (Survole)",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "pricingBtnColor",
      label: "Couleur du Bouton",
      defaultValue: "#000000",
    },
    {
      type: "color",
      name: "pricingBtnTextColor",
      label: "Couleur du Texte du Bouton",
      defaultValue: "#FFFFFF",
    },
    {
      type: "color",
      name: "pricingBtnHoverColor",
      label: "Couleur du Texte du Bouton",
    },
    {
      type: "color",
      name: "pricingBtnHoverTextColor",
      label: "Couleur du Texte du Bouton",
    },
  ],
  "Tags & Badges": [
    {
      type: "color",
      name: "tagBgColor",
      label: "Couleur de l'Arriere Plan",
    },
    {
      type: "border",
      name: "tagBorder",
      label: "Contour",
      units: ["px", "em"],
    },
    {
      type: "sizing",
      name: "tagFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
    },
    {
      type: "sizing",
      name: "tagHeight",
      label: "Hauteur",
      units: ["px", "em"],
    },
    {
      type: "sides",
      name: "tagPadding",
      label: "Espacement Interne (Padding)",
      units: ["px", "em"],
    },
    {
      type: "radius",
      name: "tagRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "color",
      name: "tagTextColor",
      label: "Couleur du Texte",
    },
    {
      type: "border",
      name: "tagActiveBorder",
      label: "Contour (Actif)",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "tagActiveBgColor",
      label: "Couleur de l'Arriere Plan (Actif)",
    },
    {
      type: "color",
      name: "tagActiveTextColor",
      label: "Couleur du Texte (Actif)",
    },
  ],
  "En-Tete de la grille": [
    {
      type: "color",
      name: "gridSorterBgColor",
      label: "Couleur de l'Arriere Plan",
    },
    {
      type: "sizing",
      name: "gridSorterFontSize",
      label: "Taille de la police",
      units: ["px", "em", "rem", "pt"],
      defaultValue: "18px",
    },
    {
      type: "radius",
      name: "gridSorterRadius",
      label: "Arrondis",
      units: ["px", "em", "%"],
    },
    {
      type: "color",
      name: "gridSorterColor",
      label: "Couleur des texte Plan",
    },
    {
      type: "sides",
      name: "gridSorterMargin",
      label: "Espacement Externe (Margin)",
      units: ["px", "em"],
    },
    {
      type: "sides",
      name: "gridSorterPadding",
      label: "Espacement Interne (Padding)",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "gridSorterSelectBgColor",
      label: "Couleur des select/option",
    },
    {
      type: "border",
      name: "gridSorterSelectBorder",
      label: "Contour des select/option",
      units: ["px", "em"],
    },
    {
      type: "color",
      name: "gridSorterSelectColor",
      label: "Couleur des textes des select/option",
    },
    {
      type: "radius",
      name: "gridSorterSelectRadius",
      label: "Arrondis des select/option",
      units: ["px", "em", "%"],
    },
  ],
  // ...SPACE
};
